import { render, staticRenderFns } from "./TemplatePestsTable.vue?vue&type=template&id=4f68e776&"
import script from "./TemplatePestsTable.vue?vue&type=script&lang=js&"
export * from "./TemplatePestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports